module.exports = __webpack_public_path__ + "assets/retina_EquilateralAboutCircleDetailed.2303ae241a10a6b674792496e1899e13.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_EquilateralAboutCircleDetailed.png
// module id = 663
// module chunks = 0